import classNames from "classnames";
import styles from "./index.module.scss";
// import TitleWhithLine from "@/components/TitleWhithLine";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import "./index.scss";
import event1 from '@/assets/images/about/event1.png'
import event2 from '@/assets/images/about/event2.png'
import intl from "react-intl-universal";
const Event = () => {
	const settings = {
		className: "centerBox",
		autoplay: true,
		autoplaySpeed: 4000,
		dots: true,
		infinite: true,
		centerMode: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		variableWidth: true
	};
	const list = [{
		imgPath: event1,
		path: '/second'
	}, {
		imgPath: event2,
		path: '/second'
	}]
	return (
		<div className={classNames('container', styles.eventBox)}>
			<div className={classNames("flex_box", "flex_between", "align_end", styles.titleBox)}>
				<span>{intl.get("About.Our amazing events & members")}</span>
				{/*<TitleWhithLine title="SEE MORE" link="/community/events" />*/}
			</div>

			<div className={styles.scroolBox}>
				<Slider {...settings}>
					{list.map((item, index) => {
						return <img className={styles.imgBox} key={index + "_event"} src={item.imgPath} />
					})}
				</Slider>
			</div>
		</div>
	)
}
export default Event;